(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bennington-oem-claim-offer-direct"]) return;
  try {
    

  $('#BenningtonCart').on('click', function(e){
    axios.post('/cart/add.js', { //Monthly
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-bennington");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#BenningtonModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-bennington");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["build-boat-package-start"]) return;
  try {
    
  //NOTE: PGCOUNT STARTS AT 0, BUT STEPS START AT 1
  // let pgCount = 0; //now relocated to <head> for use w functions
  
  // document.getElementById('byb-back-arrow').style.display = "none";
  document.getElementsByClassName("byb-step")[0].style.display = 'block';
  
  
  // function displayStep(input){
  //   console.log('in displayStep. input === ', input);
    
  //   let bybSteps = document.getElementsByClassName("byb-step");
  //   bybSteps[input].style.display = "block";
  //   if(input = 0){ 
  //     document.getElementById('byb-back-arrow').style.display = "none";
  //   }else {
  //     document.getElementById('byb-back-arrow').style.display = "inline";
  //   }
  // }

  // every time an email is sent, the code below resets the text of the modal back to the email me my button portion
  // this is necessary for those who click out of the modal or complete an email. Addtionally, we add functionality to the 
  // modal by being able to click outside the modal to exit it.
  $('#email-me-btn').on('click', function(e){
    var modal = document.getElementById("send-email-modal");
    document.body.classList.add("modal-opens")
    modal.style.display = "flex";
    let sucessHeader = document.querySelector("#send-email-modal h2");
    let successText = document.querySelector("#send-email-modal .direct-atc-modal-text");
    let sendOfferBtn = document.getElementById("send-offer-btn");
    let returnBackBtn = document.getElementById("back-to-page-btn");
    let emailInput = document.getElementById("byb-email-user-input");

    sucessHeader.innerHTML = "Save your recommendations"
    successText.textContent = "To email our recommendation, enter your email and click the button below to continue."
    returnBackBtn.classList.add("hidden-elem");
    sendOfferBtn.classList.remove("hidden-elem");
    sendOfferBtn.classList.add("byb-input-block");
    emailInput.classList.remove("hidden-elem");
    emailInput.classList.add("byb-input-block");
    emailInput.value = "";
  })
  $('#back-to-page-btn').on('click', function(e){
    var modal = document.getElementById("send-email-modal");
      modal.style.display = "none";
    document.body.classList.remove("modal-opens")
  })
  $('#SendEmailModalClose').on('click', function(e){
    var modal = document.getElementById("send-email-modal");
      modal.style.display = "none";
      document.body.classList.remove("modal-opens")
      // document.body.classList.remove("modal-blur"
  })

  // Close modal when clicking outside the modal content
  $(window).on('click', function(e) {
      var modal = document.getElementById("send-email-modal");
      if (e.target === modal) {
        var modal = document.getElementById("send-email-modal");
        modal.style.display = "none";
        document.body.classList.remove("modal-opens");
      }
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chaparral-oem-claim-offer-direct"]) return;
  try {
    

  $('#ChaparralCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-chaparral");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#ChaparralModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-chaparral");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobalt-oem-claim-offer-direct"]) return;
  try {
    

  $('#CobaltCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-cobalt");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#CobaltModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-cobalt");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cobia-oem-claim-offer-direct"]) return;
  try {
    

  $('#CobiaCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-cobia");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#CobiaModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-cobia");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contender-oem-claim-offer-direct"]) return;
  try {
    

  $('#ContenderCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#ContenderModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cutwater-oem-claim-offer-direct"]) return;
  try {
    

  $('#CutwaterCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-cutwater");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#CutwaterModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-cutwater");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["download"]) return;
  try {
    
  (function() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(ua)) {
      window.location.replace("https://play.google.com/store/apps/details?id=com.stationdm.yamahaoneapp");
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      window.location.replace("https://apps.apple.com/us/app/siren-connected-boat/id6467128040");
    }
  })();
  document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname === '/pages/download') {
      var header = document.getElementById('shopify-section-header');
      var footer = document.getElementById('shopify-section-footer');
      var topBuffer = document.querySelector('.main-content');
      if(header){
        header.style.display = 'none';
      }
      if(footer){
        footer.style.display = 'none';
      }
      if(topBuffer){
        topBuffer.style.marginTop = '0px';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["everglades-oem-claim-offer-direct"]) return;
  try {
    

  $('#EvergladesCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-everglades");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#EvergladesModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-everglades");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["g3-oem-claim-offer-direct"]) return;
  try {
    

  $('#SuncatcherCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SuncatcherModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grady-oem-claim-offer-direct"]) return;
  try {
    

  $('#GradyCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#GradyModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-billboard-home"] && !Shopify.designMode) return;
  try {
    
$("body").on("shopify:section:load", function(event) {
	var section_id = event.originalEvent.detail.sectionId,
	block_id = event.originalEvent.detail.blockId;
	swiper_init($(event.target).find(".swiper-container"), section_id);
});
$("body").on("shopify:block:select", function(event) {
	var section_id = event.originalEvent.detail.sectionId,
	slide_index = parseInt($(event.target).attr('data-slide-number'));
	var swiper = $("#shopify-section-" + section_id + " .swiper-container")[0].swiper;	
	if(swiper.realIndex != slide_index)
		swiper.slideTo(slide_index);    
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-pg-header-imgbanner"] && !Shopify.designMode) return;
  try {
    
  $('#homepg-banner-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 33869986189}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
        // var modal = document.getElementById("homepg-direct-atc-success-modal");
        // modal.style.display = "flex";
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>GETCONNECTED</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instafeed-home"] && !Shopify.designMode) return;
  try {
    
/* InstaFeed - https://github.com/stevenschobert/instafeed.js*/
(function(){var e;e=function(){function e(e,t){var n,r;this.options={target:"instafeed",get:"popular",resolution:"thumbnail",sortBy:"none",links:!0,mock:!1,useHttp:!1};if(typeof e=="object")for(n in e)r=e[n],this.options[n]=r;this.context=t!=null?t:this,this.unique=this._genKey()}return e.prototype.hasNext=function(){return typeof this.context.nextUrl=="string"&&this.context.nextUrl.length>0},e.prototype.next=function(){return this.hasNext()?this.run(this.context.nextUrl):!1},e.prototype.run=function(t){var n,r,i;if(typeof this.options.clientId!="string"&&typeof this.options.accessToken!="string")throw new Error("Missing clientId or accessToken.");if(typeof this.options.accessToken!="string"&&typeof this.options.clientId!="string")throw new Error("Missing clientId or accessToken.");return this.options.before!=null&&typeof this.options.before=="function"&&this.options.before.call(this),typeof document!="undefined"&&document!==null&&(i=document.createElement("script"),i.id="instafeed-fetcher",i.src=t||this._buildUrl(),n=document.getElementsByTagName("head"),n[0].appendChild(i),r="instafeedCache"+this.unique,window[r]=new e(this.options,this),window[r].unique=this.unique),!0},e.prototype.parse=function(e){var t,n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b,w,E,S,x,T,N,C,k,L,A,O,M,_,D;if(typeof e!="object"){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,"Invalid JSON data"),!1;throw new Error("Invalid JSON response")}if(e.meta.code!==200){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,e.meta.error_message),!1;throw new Error("Error from Instagram: "+e.meta.error_message)}if(e.data.length===0){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,"No images were returned from Instagram"),!1;throw new Error("No images were returned from Instagram")}this.options.success!=null&&typeof this.options.success=="function"&&this.options.success.call(this,e),this.context.nextUrl="",e.pagination!=null&&(this.context.nextUrl=e.pagination.next_url);if(this.options.sortBy!=="none"){this.options.sortBy==="random"?M=["","random"]:M=this.options.sortBy.split("-"),O=M[0]==="least"?!0:!1;switch(M[1]){case"random":e.data.sort(function(){return.5-Math.random()});break;case"recent":e.data=this._sortBy(e.data,"created_time",O);break;case"liked":e.data=this._sortBy(e.data,"likes.count",O);break;case"commented":e.data=this._sortBy(e.data,"comments.count",O);break;default:throw new Error("Invalid option for sortBy: '"+this.options.sortBy+"'.")}}if(typeof document!="undefined"&&document!==null&&this.options.mock===!1){m=e.data,A=parseInt(this.options.limit,10),this.options.limit!=null&&m.length>A&&(m=m.slice(0,A)),u=document.createDocumentFragment(),this.options.filter!=null&&typeof this.options.filter=="function"&&(m=this._filter(m,this.options.filter));if(this.options.template!=null&&typeof this.options.template=="string"){f="",d="",w="",D=document.createElement("div");for(c=0,N=m.length;c<N;c++){h=m[c],p=h.images[this.options.resolution];if(typeof p!="object")throw o="No image found for resolution: "+this.options.resolution+".",new Error(o);E=p.width,y=p.height,b="square",E>y&&(b="landscape"),E<y&&(b="portrait"),v=p.url,l=window.location.protocol.indexOf("http")>=0,l&&!this.options.useHttp&&(v=v.replace(/https?:\/\//,"//")),d=this._makeTemplate(this.options.template,{model:h,id:h.id,link:h.link,type:h.type,image:v,width:E,height:y,orientation:b,caption:this._getObjectProperty(h,"caption.text"),likes:h.likes.count,comments:h.comments.count,location:this._getObjectProperty(h,"location.name")}),f+=d}D.innerHTML=f,i=[],r=0,n=D.childNodes.length;while(r<n)i.push(D.childNodes[r]),r+=1;for(x=0,C=i.length;x<C;x++)L=i[x],u.appendChild(L)}else for(T=0,k=m.length;T<k;T++){h=m[T],g=document.createElement("img"),p=h.images[this.options.resolution];if(typeof p!="object")throw o="No image found for resolution: "+this.options.resolution+".",new Error(o);v=p.url,l=window.location.protocol.indexOf("http")>=0,l&&!this.options.useHttp&&(v=v.replace(/https?:\/\//,"//")),g.src=v,this.options.links===!0?(t=document.createElement("a"),t.href=h.link,t.appendChild(g),u.appendChild(t)):u.appendChild(g)}_=this.options.target,typeof _=="string"&&(_=document.getElementById(_));if(_==null)throw o='No element with id="'+this.options.target+'" on page.',new Error(o);_.appendChild(u),a=document.getElementsByTagName("head")[0],a.removeChild(document.getElementById("instafeed-fetcher")),S="instafeedCache"+this.unique,window[S]=void 0;try{delete window[S]}catch(P){s=P}}return this.options.after!=null&&typeof this.options.after=="function"&&this.options.after.call(this),!0},e.prototype._buildUrl=function(){var e,t,n;e="https://api.instagram.com/v1";switch(this.options.get){case"popular":t="media/popular";break;case"tagged":if(!this.options.tagName)throw new Error("No tag name specified. Use the 'tagName' option.");t="tags/"+this.options.tagName+"/media/recent";break;case"location":if(!this.options.locationId)throw new Error("No location specified. Use the 'locationId' option.");t="locations/"+this.options.locationId+"/media/recent";break;case"user":if(!this.options.userId)throw new Error("No user specified. Use the 'userId' option.");t="users/"+this.options.userId+"/media/recent";break;default:throw new Error("Invalid option for get: '"+this.options.get+"'.")}return n=e+"/"+t,this.options.accessToken!=null?n+="?access_token="+this.options.accessToken:n+="?client_id="+this.options.clientId,this.options.limit!=null&&(n+="&count="+this.options.limit),n+="&callback=instafeedCache"+this.unique+".parse",n},e.prototype._genKey=function(){var e;return e=function(){return((1+Math.random())*65536|0).toString(16).substring(1)},""+e()+e()+e()+e()},e.prototype._makeTemplate=function(e,t){var n,r,i,s,o;r=/(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,n=e;while(r.test(n))s=n.match(r)[1],o=(i=this._getObjectProperty(t,s))!=null?i:"",n=n.replace(r,function(){return""+o});return n},e.prototype._getObjectProperty=function(e,t){var n,r;t=t.replace(/\[(\w+)\]/g,".$1"),r=t.split(".");while(r.length){n=r.shift();if(!(e!=null&&n in e))return null;e=e[n]}return e},e.prototype._sortBy=function(e,t,n){var r;return r=function(e,r){var i,s;return i=this._getObjectProperty(e,t),s=this._getObjectProperty(r,t),n?i>s?1:-1:i<s?1:-1},e.sort(r.bind(this)),e},e.prototype._filter=function(e,t){var n,r,i,s,o;n=[],r=function(e){if(t(e))return n.push(e)};for(i=0,o=e.length;i<o;i++)s=e[i],r(s);return n},e}(),function(e,t){return typeof define=="function"&&define.amd?define([],t):typeof module=="object"&&module.exports?module.exports=t():e.Instafeed=t()}(this,function(){return e})}).call(this);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instafeed-static"]) return;
  try {
    
/* InstaFeed - https://github.com/stevenschobert/instafeed.js*/
(function(){var e;e=function(){function e(e,t){var n,r;this.options={target:"instafeed",get:"popular",resolution:"thumbnail",sortBy:"none",links:!0,mock:!1,useHttp:!1};if(typeof e=="object")for(n in e)r=e[n],this.options[n]=r;this.context=t!=null?t:this,this.unique=this._genKey()}return e.prototype.hasNext=function(){return typeof this.context.nextUrl=="string"&&this.context.nextUrl.length>0},e.prototype.next=function(){return this.hasNext()?this.run(this.context.nextUrl):!1},e.prototype.run=function(t){var n,r,i;if(typeof this.options.clientId!="string"&&typeof this.options.accessToken!="string")throw new Error("Missing clientId or accessToken.");if(typeof this.options.accessToken!="string"&&typeof this.options.clientId!="string")throw new Error("Missing clientId or accessToken.");return this.options.before!=null&&typeof this.options.before=="function"&&this.options.before.call(this),typeof document!="undefined"&&document!==null&&(i=document.createElement("script"),i.id="instafeed-fetcher",i.src=t||this._buildUrl(),n=document.getElementsByTagName("head"),n[0].appendChild(i),r="instafeedCache"+this.unique,window[r]=new e(this.options,this),window[r].unique=this.unique),!0},e.prototype.parse=function(e){var t,n,r,i,s,o,u,a,f,l,c,h,p,d,v,m,g,y,b,w,E,S,x,T,N,C,k,L,A,O,M,_,D;if(typeof e!="object"){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,"Invalid JSON data"),!1;throw new Error("Invalid JSON response")}if(e.meta.code!==200){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,e.meta.error_message),!1;throw new Error("Error from Instagram: "+e.meta.error_message)}if(e.data.length===0){if(this.options.error!=null&&typeof this.options.error=="function")return this.options.error.call(this,"No images were returned from Instagram"),!1;throw new Error("No images were returned from Instagram")}this.options.success!=null&&typeof this.options.success=="function"&&this.options.success.call(this,e),this.context.nextUrl="",e.pagination!=null&&(this.context.nextUrl=e.pagination.next_url);if(this.options.sortBy!=="none"){this.options.sortBy==="random"?M=["","random"]:M=this.options.sortBy.split("-"),O=M[0]==="least"?!0:!1;switch(M[1]){case"random":e.data.sort(function(){return.5-Math.random()});break;case"recent":e.data=this._sortBy(e.data,"created_time",O);break;case"liked":e.data=this._sortBy(e.data,"likes.count",O);break;case"commented":e.data=this._sortBy(e.data,"comments.count",O);break;default:throw new Error("Invalid option for sortBy: '"+this.options.sortBy+"'.")}}if(typeof document!="undefined"&&document!==null&&this.options.mock===!1){m=e.data,A=parseInt(this.options.limit,10),this.options.limit!=null&&m.length>A&&(m=m.slice(0,A)),u=document.createDocumentFragment(),this.options.filter!=null&&typeof this.options.filter=="function"&&(m=this._filter(m,this.options.filter));if(this.options.template!=null&&typeof this.options.template=="string"){f="",d="",w="",D=document.createElement("div");for(c=0,N=m.length;c<N;c++){h=m[c],p=h.images[this.options.resolution];if(typeof p!="object")throw o="No image found for resolution: "+this.options.resolution+".",new Error(o);E=p.width,y=p.height,b="square",E>y&&(b="landscape"),E<y&&(b="portrait"),v=p.url,l=window.location.protocol.indexOf("http")>=0,l&&!this.options.useHttp&&(v=v.replace(/https?:\/\//,"//")),d=this._makeTemplate(this.options.template,{model:h,id:h.id,link:h.link,type:h.type,image:v,width:E,height:y,orientation:b,caption:this._getObjectProperty(h,"caption.text"),likes:h.likes.count,comments:h.comments.count,location:this._getObjectProperty(h,"location.name")}),f+=d}D.innerHTML=f,i=[],r=0,n=D.childNodes.length;while(r<n)i.push(D.childNodes[r]),r+=1;for(x=0,C=i.length;x<C;x++)L=i[x],u.appendChild(L)}else for(T=0,k=m.length;T<k;T++){h=m[T],g=document.createElement("img"),p=h.images[this.options.resolution];if(typeof p!="object")throw o="No image found for resolution: "+this.options.resolution+".",new Error(o);v=p.url,l=window.location.protocol.indexOf("http")>=0,l&&!this.options.useHttp&&(v=v.replace(/https?:\/\//,"//")),g.src=v,this.options.links===!0?(t=document.createElement("a"),t.href=h.link,t.appendChild(g),u.appendChild(t)):u.appendChild(g)}_=this.options.target,typeof _=="string"&&(_=document.getElementById(_));if(_==null)throw o='No element with id="'+this.options.target+'" on page.',new Error(o);_.appendChild(u),a=document.getElementsByTagName("head")[0],a.removeChild(document.getElementById("instafeed-fetcher")),S="instafeedCache"+this.unique,window[S]=void 0;try{delete window[S]}catch(P){s=P}}return this.options.after!=null&&typeof this.options.after=="function"&&this.options.after.call(this),!0},e.prototype._buildUrl=function(){var e,t,n;e="https://api.instagram.com/v1";switch(this.options.get){case"popular":t="media/popular";break;case"tagged":if(!this.options.tagName)throw new Error("No tag name specified. Use the 'tagName' option.");t="tags/"+this.options.tagName+"/media/recent";break;case"location":if(!this.options.locationId)throw new Error("No location specified. Use the 'locationId' option.");t="locations/"+this.options.locationId+"/media/recent";break;case"user":if(!this.options.userId)throw new Error("No user specified. Use the 'userId' option.");t="users/"+this.options.userId+"/media/recent";break;default:throw new Error("Invalid option for get: '"+this.options.get+"'.")}return n=e+"/"+t,this.options.accessToken!=null?n+="?access_token="+this.options.accessToken:n+="?client_id="+this.options.clientId,this.options.limit!=null&&(n+="&count="+this.options.limit),n+="&callback=instafeedCache"+this.unique+".parse",n},e.prototype._genKey=function(){var e;return e=function(){return((1+Math.random())*65536|0).toString(16).substring(1)},""+e()+e()+e()+e()},e.prototype._makeTemplate=function(e,t){var n,r,i,s,o;r=/(?:\{{2})([\w\[\]\.]+)(?:\}{2})/,n=e;while(r.test(n))s=n.match(r)[1],o=(i=this._getObjectProperty(t,s))!=null?i:"",n=n.replace(r,function(){return""+o});return n},e.prototype._getObjectProperty=function(e,t){var n,r;t=t.replace(/\[(\w+)\]/g,".$1"),r=t.split(".");while(r.length){n=r.shift();if(!(e!=null&&n in e))return null;e=e[n]}return e},e.prototype._sortBy=function(e,t,n){var r;return r=function(e,r){var i,s;return i=this._getObjectProperty(e,t),s=this._getObjectProperty(r,t),n?i>s?1:-1:i<s?1:-1},e.sort(r.bind(this)),e},e.prototype._filter=function(e,t){var n,r,i,s,o;n=[],r=function(e){if(t(e))return n.push(e)};for(i=0,o=e.length;i<o;i++)s=e[i],r(s);return n},e}(),function(e,t){return typeof define=="function"&&define.amd?define([],t):typeof module=="object"&&module.exports?module.exports=t():e.Instafeed=t()}(this,function(){return e})}).call(this);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jupiter-oem-claim-offer-direct"]) return;
  try {
    

  $('#JupiterCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-jupiter");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#JupiterModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-jupiter");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["keywest-oem-claim-offer-direct"]) return;
  try {
    

  $('#KeyWestCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#KeyWestModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kingfisher-oem-claim-offer-direct"]) return;
  try {
    

  $('#KingfisherCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#KingfisherModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-banner-yearendsale"]) return;
  try {
    
  $('#yearendsale-lmtd-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 34155893005, selling_plan: 3602317382},
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 31891393577030}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>YEARENDSALE</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  });
  $('#yearendsale-lmtd-off-btn2').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 34155893005, selling_plan: 3602317382},
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 31891393577030}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>YEARENDSALE</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-banner-yearendsale400"]) return;
  try {
    
  $('#yearendsale-lmtd-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 34155893005, selling_plan: 3602317382},
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 31891393577030}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>YEAREND400</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  });
  $('#yearendsale-lmtd-off-btn2').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 34155893005, selling_plan: 3602317382},
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 31891393577030}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>YEAREND400</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["parker-oem-claim-offer-direct"]) return;
  try {
    

  $('#ParkerCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-parker");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#ParkerModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-parker");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prebuilt-boat-package-bundles-collection"]) return;
  try {
    
  function constructForm(dataPkg) {
    const formData = new URLSearchParams();

    dataPkg.items.forEach((item, index) => {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
      if (item.selling_plan) {
        formData.append(`items[${index}][selling_plan]`, item.selling_plan);
      }
    });

    return formData.toString();
  }
  // $('.byb-add-to-cart-btn').on('click', function (e) {
  //   console.log('btn click')
  //   const kit = this.id; 
  //   let cartPkg;
  //   switch(kit){
  //     case 'Kit1Bundle':
  //       console.log('kit1');
  //       cartPkg = {
  //         items: [
  //           {quantity: 1, id: 31927087530054}, 
  //           { id: 31321968934982, quantity: 1, selling_plan: 3601727558 } //free trial sub
  //         ]
  //       }
  //       break;
  //     case 'Kit2Bundle':
  //       break;
  //     case 'Kit3Bundle':
  //       break;
  //     case 'Kit4Bundle':
  //       break;
  //     case 'Kit5Bundle':
  //       break;
  //     case 'Kit6Bundle':
  //       break;
  //     default:
  //       console.log('invalid kit ID passed');
  //   }
  //   const toCartForm = constructForm(dataPkg);
  //   axios.post('/cart/add.js', toCartForm, {
  //     headers: {
  //       'Content-Type': 'application/x-www-form-urlencoded'
  //     }
  //   })
  //     .then(function (response) {
  //       console.log('success res: ', response);
  //       return axios.get('/cart.js');
  //     })
  //     .then(function(response){
  //       var cartCountHTML = $('#CartCount');
  //       cartCountHTML.text(response.data.item_count);
  //     })
  //     .then(function (b) {
  //       swal({
  //         title: '<span style="color:#f16921">Success!</span>',
  //         html: true,
  //         showCloseButton:false,
  //         showConfirmButton:false,
  //         showCancelButton:false,
  //         text:
  //           '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
  //       });
  //       $("#goToCart").click(() => {
  //         window.location.href="/cart"
  //       });
  //     })
  //     .catch(function (error) {
  //       console.log('error: ', error);
  //     });
  //   })
  $('#Kit1Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43672808456262}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#Kit2Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43702397894726}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#Kit3Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43702400680006}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#Kit4Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43702410346566}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#Kit5Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43702410608710}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#Kit6Bundle').on('click', function(z){
    const dataPkg = {
      items: [ 
        { id: 31321968934982, quantity: 1, selling_plan: 3601727558 }, //free trial sub
        {quantity: 1, id: 43702410444870}
      ]
    };
    const toCartForm = constructForm(dataPkg);
    axios.post('/cart/add.js', toCartForm, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          window.location.href="/cart"
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
/*!
	Zoom 1.7.18
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function(o){var t={url:!1,callback:!1,target:!1,duration:120,on:"mouseover",touch:!0,onZoomIn:!1,onZoomOut:!1,magnify:1};o.zoom=function(t,n,e,i){var u,c,a,r,m,l,s,f=o(t),h=f.css("position"),d=o(n);return t.style.position=/(absolute|fixed)/.test(h)?h:"relative",t.style.overflow="hidden",e.style.width=e.style.height="",o(e).addClass("zoomImg").css({position:"absolute",top:0,left:0,opacity:0,width:e.width*i,height:e.height*i,border:"none",maxWidth:"none",maxHeight:"none"}).appendTo(t),{init:function(){c=f.outerWidth(),u=f.outerHeight(),n===t?(r=c,a=u):(r=d.outerWidth(),a=d.outerHeight()),m=(e.width-c)/r,l=(e.height-u)/a,s=d.offset()},move:function(o){var t=o.pageX-s.left,n=o.pageY-s.top;n=Math.max(Math.min(n,a),0),t=Math.max(Math.min(t,r),0),e.style.left=t*-m+"px",e.style.top=n*-l+"px"}}},o.fn.zoom=function(n){return this.each(function(){var e=o.extend({},t,n||{}),i=e.target&&o(e.target)[0]||this,u=this,c=o(u),a=document.createElement("img"),r=o(a),m="mousemove.zoom",l=!1,s=!1;if(!e.url){var f=u.querySelector("img");if(f&&(e.url=f.getAttribute("data-src")||f.currentSrc||f.src),!e.url)return}c.one("zoom.destroy",function(o,t){c.off(".zoom"),i.style.position=o,i.style.overflow=t,a.onload=null,r.remove()}.bind(this,i.style.position,i.style.overflow)),a.onload=function(){function t(t){f.init(),f.move(t),r.stop().fadeTo(o.support.opacity?e.duration:0,1,o.isFunction(e.onZoomIn)?e.onZoomIn.call(a):!1)}function n(){r.stop().fadeTo(e.duration,0,o.isFunction(e.onZoomOut)?e.onZoomOut.call(a):!1)}var f=o.zoom(i,u,a,e.magnify);"grab"===e.on?c.on("mousedown.zoom",function(e){1===e.which&&(o(document).one("mouseup.zoom",function(){n(),o(document).off(m,f.move)}),t(e),o(document).on(m,f.move),e.preventDefault())}):"click"===e.on?c.on("click.zoom",function(e){return l?void 0:(l=!0,t(e),o(document).on(m,f.move),o(document).one("click.zoom",function(){n(),l=!1,o(document).off(m,f.move)}),!1)}):"toggle"===e.on?c.on("click.zoom",function(o){l?n():t(o),l=!l}):"mouseover"===e.on&&(f.init(),c.on("mouseenter.zoom",t).on("mouseleave.zoom",n).on(m,f.move)),e.touch&&c.on("touchstart.zoom",function(o){o.preventDefault(),s?(s=!1,n()):(s=!0,t(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0]))}).on("touchmove.zoom",function(o){o.preventDefault(),f.move(o.originalEvent.touches[0]||o.originalEvent.changedTouches[0])}).on("touchend.zoom",function(o){o.preventDefault(),s&&(s=!1,n())}),o.isFunction(e.callback)&&e.callback.call(a)},a.src=e.url})},o.fn.zoom.defaults=t})(window.jQuery);

$(document).ready(function(){

  if($(window).width() >= 780) $('.zoom-image').zoom();

  $('.thumb-select img').click(function() {
	$("#ProductPhotoImg").attr('src', $(this).attr('data-src'));
	$("#ProductPhotoImg").attr('alt', $(this).attr('alt'));
	$('.zoom-image').trigger('zoom.destroy');
	$('.zoom-image').zoom();
  });  
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pursuit-oem-claim-offer-direct"]) return;
  try {
    

  $('#PursuitCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#PursuitModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ranger-tugs-oem-claim-offer-direct"]) return;
  try {
    

  $('#RangerTugsCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-ranger-tugs");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#RangerTugsModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-ranger-tugs");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regal-oem-claim-offer-direct"]) return;
  try {
    

  $('#RegalCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-regal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#RegalModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-regal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["regulator-oem-claim-offer-direct"]) return;
  try {
    

  $('#RegulatorCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#RegulatorModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renaissance-oem-claim-offer-direct"]) return;
  try {
    

  $('#RenaissanceCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-renaissance");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#RenaissanceModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-renaissance");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["robalo-oem-claim-offer-direct"]) return;
  try {
    

  $('#RobaloCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-robalo");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#RobaloModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-robalo");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sailfish-oem-claim-offer-direct"]) return;
  try {
    

  $('#SailfishCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-sailfish");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SailfishModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-sailfish");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scout-oem-claim-offer-direct"]) return;
  try {
    

  $('#ScoutCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#ScoutModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sea-fox-oem-claim-offer-direct"]) return;
  try {
    

  $('#SeaFoxCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SeaFoxModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seahunt-oem-claim-offer-direct"]) return;
  try {
    

  $('#SeaHuntCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SeaHuntModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seahunter-oem-claim-offer-direct"]) return;
  try {
    

  $('#SeaHunterCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-seahunter");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SeaHunterModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-seahunter");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skeeter-oem-claim-offer-direct"]) return;
  try {
    
  $('#SkeeterCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-skeeter");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SkeeterModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-skeeter");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solace-oem-claim-offer-direct"]) return;
  try {
    

  $('#SolaceCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-solace");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SolaceModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-solace");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solara-oem-claim-offer-direct"]) return;
  try {
    

  $('#SolaraCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-solara");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SolaraModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-solara");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["speciale-demo-oem-claim-offer-direct"]) return;
  try {
    
  $('#SpecialeCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-speciale");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SpecialeModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-speciale");
      modal.style.display = "none";
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sportsman-oem-claim-offer-direct"]) return;
  try {
    

  $('#SportsmanCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-sportsman");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#SportsmanModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-sportsman");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stuart-oem-claim-offer-direct"]) return;
  try {
    

  $('#StuartBoatworksCart').on('click', function(e){
    axios.post('/cart/add.js', {
        quantity: 1,
        id: 34155893005,
        selling_plan: 3602317382
      })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-stuartboatworks");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#StuartBoatworksModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-stuartboatworks");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tidewater-oem-claim-offer-direct"]) return;
  try {
    

  $('#TidewaterCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#TidewaterModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["veranda-oem-claim-offer-direct"]) return;
  try {
    

  $('#VerandaCart').on('click', function(e){
    axios.post('/cart/add.js', { //Monthly
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-veranda");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#VerandaModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-veranda");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weldcraft-oem-claim-offer-direct"]) return;
  try {
    

  $('#WeldcraftCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-weldcraft");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#WeldcraftModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-weldcraft");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["worldcat-oem-claim-offer-direct"]) return;
  try {
    

  $('#WorldcatCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-worldcat");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#WorldcatModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-worldcat");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-connectedyear-banner"]) return;
  try {
    
  $('#connectedyear-minibanner-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 33869986189}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
        // var modal = document.getElementById("yamaha-direct-atc-success-modal");
        // modal.style.display = "flex";
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>CONNECTEDYEAR</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-connectedyear-offer"]) return;
  try {
    
  $('#connectedyear-lmtd-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 33869986189}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>CONNECTEDYEAR</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-limited-offer"]) return;
  try {
    
  $('#yamaha-lmtd-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 33869986189}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>GETCONNECTED</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-oem-claim-offer-direct"]) return;
  try {
    

  $('#HMEXCart').on('click', function(e){
    axios.post('/cart/add.js', { //Annual
      quantity: 1,
      id: 33869986189,
      selling_plan: 3602120774
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#HMEXModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamaha-siren-tiers-header"] && !Shopify.designMode) return;
  try {
    
  $('#yamaha-banner-off-btn').on('click', function(z){
    axios.post('/cart/add.js', {
      items: [
        {quantity: 1, id: 31927087530054},
        {quantity: 1, id: 33869986189}
      ]
    })
      .then(function (response) {
        console.log('success res: ', response);
        return axios.get('/cart.js');
      })
      .then(function(response){
        var cartCountHTML = $('#CartCount');
        cartCountHTML.text(response.data.item_count);
        // var modal = document.getElementById("yamaha-direct-atc-success-modal");
        // modal.style.display = "flex";
      })
      .then(function (b) {
        swal({
          title: '<span style="color:#f16921">Success!</span>',
          html: true,
          showCloseButton:false,
          showConfirmButton:false,
          showCancelButton:false,
          text:
            '<p>Items have been added to cart.</p><br><p>Enter code <b>GETCONNECTED</b> at checkout to finish claiming your offer!</p><div><button id="closeModal" style="border: 1px solid #f16921;color:#f16921;background-color:white;border-radius:10px;padding:7px 32px">Keep Shopping</button><button id="goToCart" style="background-color:#f16921;border-radius:10px;padding:7px 32px">Go to Cart</button></div>',
        });
        $("#goToCart").click(() => {
          // window.location.href="/cart"
          window.open("/cart", "_blank");
        });
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yamahajet-oem-claim-offer-direct"]) return;
  try {
    

  $('#YamahajetCart').on('click', function(e){
    axios.post('/cart/add.js', {
      quantity: 1,
      id: 34155893005,
      selling_plan: 3602317382
    })
      .then(function (response) {
        console.log('success res: ', response);
        var modal = document.getElementById("direct-atc-success-modal-yamahajet");
        modal.style.display = "flex";
        //updateCartCount(1);
        
      })
      .catch(function (error) {
        console.log('error: ', error);
      });
  })
  $('#YamahajetModalClose').on('click', function(e){
    var modal = document.getElementById("direct-atc-success-modal-yamahajet");
      modal.style.display = "none";
  })
  

  } catch(e) { console.error(e); }
})();
})();
